import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import SEOHead from "@/components/SEOHead";

const Unsubscribe = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";
  const [undone, setUndone] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleUndo = async () => {
    if (!token || loading) return;
    setLoading(true);
    try {
      const { error } = await supabase.functions.invoke("update-email-subscription", {
        body: { token, subscribed: true },
      });
      if (error) throw error;
      setUndone(true);
      toast.success("You've been resubscribed to email reminders.");
    } catch {
      toast.error("Something went wrong. Try again or visit Settings.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SEOHead title="Unsubscribe — Dearestly." description="Manage your Dearestly. email subscription." path="/unsubscribe" noindex />
      <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card p-8 text-center shadow-sm">
        <div className="mb-6 text-[56px]">📭</div>

        {undone ? (
          <>
            <h1 className="mb-3 font-serif text-2xl font-semibold text-foreground">
              Welcome back!
            </h1>
            <p className="mb-6 text-sm leading-relaxed text-muted-foreground">
              Your email reminders have been turned back on. You'll continue receiving birthday
              reminders from Dearestly
            </p>
          </>
        ) : (
          <>
            <h1 className="mb-3 font-serif text-2xl font-semibold text-foreground">
              You've been unsubscribed
            </h1>
            <p className="mb-6 text-sm leading-relaxed text-muted-foreground">
              You won't receive birthday reminder emails from Dearestly anymore. You can always
              re-enable them from your Settings.
            </p>

            {token && (
              <button
                onClick={handleUndo}
                disabled={loading}
                className="mb-4 text-sm font-medium text-accent hover:underline disabled:opacity-50"
              >
                {loading ? "Resubscribing…" : "I didn't mean to — undo this"}
              </button>
            )}
          </>
        )}

        <div className="mt-2">
          <Button
            onClick={() => navigate("/settings/reminders")}
            className="w-full rounded-full"
            size="lg"
          >
            Go to my Settings
          </Button>
        </div>

        <p className="mt-6 text-xs text-muted-foreground">
          You can re-enable email reminders anytime from{" "}
          <button onClick={() => navigate("/settings/reminders")} className="underline">
            Settings → Reminders
          </button>
          .
        </p>
      </div>
    </div>
  </>
  );
};

export default Unsubscribe;
